import '@babel/polyfill';
import 'element-closest-polyfill';
import 'nodelist-foreach-polyfill';
import 'smoothscroll-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import Raven from 'raven-js';
import smoothscroll from 'smoothscroll-polyfill';

// Smoothscroll polyfill has to be initialized manually
// https://github.com/iamdustan/smoothscroll
smoothscroll.polyfill();

// Quickly mock recaptcha in case it's not available, just so that the app doesn't break
window.grecaptcha = window.grecaptcha || {
  execute: function() { return 'recaptcha_token'; }
};

export default function renderComponent(Component, rootElementId) {
  document.addEventListener('DOMContentLoaded', () => {
    const sentryDsn = document.querySelectorAll('meta[name="sentry-dsn"]')[0]?.getAttribute('content');
    if (sentryDsn) {
      Raven.config(sentryDsn).install();
    }

    const csrfToken = document.querySelectorAll('meta[name="csrf-token"]')[0]?.getAttribute('content');
    const rootElement = rootElementId ? document.getElementById(rootElementId) : document.body;
    const componentProps = JSON.parse(rootElement.getAttribute('data-props') || '{}');
    const cache = cache ? cache : new InMemoryCache();

    const client = new ApolloClient({
      link: new HttpLink({
        uri: '/graphql',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        credentials: 'same-origin',
      }),
      cache: cache
    });

    ReactDOM.render(
      <ApolloProvider client={client}>
        <Component {...componentProps} />
      </ApolloProvider>,
      rootElement.appendChild(document.createElement('div')),
    );
  });
}
